// import "./App.css";
import AllRoutes from "./Routes/Routes";
import Navbar from "./Components/Navbar";
import Home from "./Components/home/Home";
import ZoomAttendanceLanding from './Components/home/LandingPage'
import SingleDevDataWithCalUI from "./Pages/SingleDevDataWithCalUI";
import AddParticipantForm from "./Pages/Registration";
import { useAuth } from './context/AuthContext';
import { useEffect, useState } from "react";
import ServerDown from "./Pages/ServerDownPage";
import DataSevices from "./Services/DataSevices";
import {
  BrowserRouter,
  Route,
  Routes
} from "react-router-dom";

import DashboardV3 from "./Pages/DashboardV3";

function App() {
  const { user } = useAuth();
  const [serverDown, setServerDown] = useState(true);
const [loading, setLoading] = useState(true);
useEffect(() => {
  let timeout;

  const checkServerHealth = async () => {
    timeout = setTimeout(() => {
      setServerDown(true);
      setLoading(false);
    }, 5000);

    try {
      await DataSevices.apiHealthCheck();

      clearTimeout(timeout);

      setServerDown(false);
    } catch (error) {
      console.error("Error calling health api:", error);

      clearTimeout(timeout);

      setServerDown(true);
    } finally {
      setLoading(false);
    }
  };

  checkServerHealth();

  return () => {
    clearTimeout(timeout);
  };
}, []);

  useEffect(() => {

  }, [user])


  if (loading) {
    return (
      <div className="min-vh-100 d-flex justify-content-center align-items-center">
        <div className="spinner-border text-warning"></div>
      </div>
    );
  }

if (serverDown) {
    return <ServerDown />;
 }
 else {
 return (
     <>
       <BrowserRouter>
         {!user ?
           <Routes>
             <Route
               index
               path='*'
               element={
                 <ZoomAttendanceLanding />
               }
             />
           </Routes>
           :
           <>
             <Routes>
               <Route
                 path="/dashboard"
                 element={
                   <DashboardV3 />
                 } />

              <Route
                  path="/registration"
                  element={
                    <AddParticipantForm />
                  } />

               <Route
                 path="/dashboard/devoteesJapa"
                 element={
                   <SingleDevDataWithCalUI />
                 }
               />
             </Routes>
           </>
         }
       </BrowserRouter>

     </>

   );

 }

}

export default App;
